var p = (d, i, o) => new Promise((a, n) => {
  var l = (e) => {
    try {
      s(o.next(e));
    } catch (r) {
      n(r);
    }
  }, m = (e) => {
    try {
      s(o.throw(e));
    } catch (r) {
      n(r);
    }
  }, s = (e) => e.done ? a(e.value) : Promise.resolve(e.value).then(l, m);
  s((o = o.apply(d, i)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { vCopyVueucStylesToShadowDom as g } from "../../utils/vCopyVueucStylesToShadowDom.js";
import C from "./ManagementList.vue.js";
import { defineComponent as y, useTemplateRef as h, withDirectives as S, openBlock as _, createBlock as k, withCtx as u, createVNode as c } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useShadowRoot as M } from "../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { unref as t } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import O from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/common/zhCN.js";
import I from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/date/zhCN.js";
import R from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/config-provider/src/ConfigProvider.js";
import L from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/MessageProvider.js";
const H = /* @__PURE__ */ y({
  __name: "index.ce",
  setup(d, { expose: i }) {
    const o = h("managementListRefs");
    let a = null;
    const n = M(), l = {
      common: {
        primaryColor: "#FC9153",
        primaryColorHover: "#FC9153",
        primaryColorPressed: "#FC9153",
        primaryColorSuppl: "#FC9153"
      }
    }, m = (e) => p(this, null, function* () {
      var r;
      return console.log(e, "v"), (r = o.value) == null || r.open({
        fictitiousShopId: e.fictitiousShopId || "",
        orgId: e.orgId || "",
        brand: e.brand || "",
        category: e.category || "",
        productChannel: e.productChannel || "",
        promotionType: e.promotionType || "",
        sendOrderStatus: e.sendOrderStatus || "",
        notIncludeOrgBelongMarketClassifyList: e.notIncludeOrgBelongMarketClassifyList || "",
        oldOrderStatus: e.oldOrderStatus || "",
        normalOrderStatus: e.normalOrderStatus || "",
        orgBelongMarketClassifyList: e.orgBelongMarketClassifyList || "",
        orgMarketManageRightId: e.orgMarketManageRightId || ""
      }), new Promise((f) => {
        a = f;
      });
    }), s = (e) => {
      a && (a(e), a = null);
    };
    return i({ open: m }), (e, r) => S((_(), k(t(R), {
      locale: t(O),
      "date-locale": t(I),
      "theme-overrides": l,
      "style-mount-target": t(n)
    }, {
      default: u(() => [
        c(t(L), null, {
          default: u(() => [
            c(C, {
              ref_key: "managementListRefs",
              ref: o,
              onSubmit: s
            }, null, 512)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["locale", "date-locale", "style-mount-target"])), [
      [t(g), t(n)]
    ]);
  }
});
export {
  H as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/manage-mentList/index.ce.vue2.js
// module id = 1266
// module chunks = 41